import _extends from '@babel/runtime/helpers/extends';
import { px2rem } from '../utils/helpers/style.js';
import { colors } from '../constants/colors.js';

var fileUploadThemeWeb = {
  backgroundSecondary: colors.lightGrey,
  width: px2rem(362),
  height: px2rem(152),
  borderColor: colors.fogGrey,
  inactiveText: colors.fogGrey,
  focus: {
    background: colors.lightGrey,
    outlineColor: colors.forestGreen
  },
  listItem: {
    background: colors.lightGrey
  }
};
var fileUploadDarkThemeWeb = _extends({}, fileUploadThemeWeb, {
  backgroundSecondary: colors.mineShaftGrey,
  borderColor: colors.octoberGrey,
  inactiveText: colors.octoberGrey,
  focus: {
    background: colors.mineShaftGrey,
    outlineColor: colors.optimisticGreen
  },
  listItem: {
    background: colors.mineShaftGrey
  }
});

export { fileUploadDarkThemeWeb, fileUploadThemeWeb };
